<template>
  <div class="main-container">
    <canvas id="canvasRender" style="z-index: 100"></canvas>
  </div>
  <HouseTypeListComponent 
  ref="houseTypeListComponent"
    :house-types="houseTypes"
    @type-selected="handleTypeSelect"
  />
  <!-- 添加蒙层元素 -->
  <div v-if="showOverlay" class="overlay"></div>
</template>
<script>
import {getCommunityDetail, isMember, getResidentialByCode, getRoadByCode, checkPageAccess, checkPwd} from '@/utils/api'
import { getHouseType, getHouseListByType } from '@/utils/houseTypeApi'
import HouseTypeViewOpen  from './HouseType'
import { Modal } from 'ant-design-vue';
import { h } from 'vue';
import HouseTypeListComponent from '@/components/HouseTypeListComponent.vue';
let houseTypeView = null;

export default {
  components: {
    HouseTypeListComponent
  },
  data() {
    return {
      buildNumbers: [],
      houseTypes: [],
      showOverlay: false,
      code: ''
    }
  },
  mounted() {

  },
  created() {
    checkPageAccess(this.$route.params.code, 4).then((res) => {
      if (res.data.code === 200) {
        this.code = res.data.result
        this.initPage(res.data.result);
      } else {
        if(res.data.result){
          this.needPassword = true;
          this.showPasswordModal(res.data.result);
        }else{
          Modal.error({
            title: '提示',
            content: res.data.message || '检查页面访问权限失败',
          });
        }
      }
    }).catch((error) => {
      console.error('网络请求出错', error);
      Modal.error({
        title: '提示',
        content: '网络请求出错，请稍后重试',
      })
    })
  },
  methods: {
    showPasswordModal(id){
      Modal.confirm({
        title: '请输入密码',
        content: h('input', {
          style: 'border: 1px solid #ccc; border-radius: 4px;',
          type: 'password',
          value: this.password,
          placeholder: '请输入访问密码',
          onInput: (e) => this.password = e.target.value
        }),
        okText: '确认',
        cancelText: '取消',
        onOk: () => this.checkPassword(id),
        onCancel: () => {}
      });
    },
    checkPassword (id) {
      checkPwd(id, this.password).then((res) => {
        this.code = res.data.result
        if (res.data.code === 200) {
          this.initPage(res.data.result);
          this.needPassword = false;
        } else {
          Modal.error({
            title: '提示',
            content: res.data.message || '密码错误，请重新输入',
            okText: '重新输入',
            onOk: () => {
              this.password = ''; // 清空密码输入框内容
              this.showPasswordModal(id); // 重新打开密码输入框
            }
          });
        }
      })
    },
    async initPage(code){
      document.title = "3D楼盘建模大师";
      await getResidentialByCode(code).then((res) => {
        if (res.data.code === 200) {
          this.residentialName = res.data.result.residentialName;
        }
      })

      await isMember(code).then((res) => {
        if(res.data.result != null && res.data.result.businessMemberType === 3){
          document.title = this.residentialName;
        }
        if(res.data.result != null && res.data.result.businessMemberType !== 3){
          this.showOverlay = true;
          Modal.error({
            title: '提示',
            content: '当前账号未开通会员服务，该页面暂停访问',
            zIndex: 1002
          })
        }
        if (res.data.result == null) {
          this.watermark = ['3D楼盘建模大师', '秦皇岛三角龙科技有限公司'];
        }
      })
      if(this.showOverlay === true){
        return
      }

      await getCommunityDetail(code).then((res) => {
        if (res.data.code === 200) {
          let minBaseHeight = 0;
          let result = res.data.result;
          result.barrierReqList.forEach(element => {
            if (element.houseList.length > 0) {
              this.buildNumbers.push(element.buildingNumber);
            }
            if (element.baseHeight < minBaseHeight || minBaseHeight === 0) {
              minBaseHeight = element.baseHeight;
            }
          });
          // 对 buildNumbers 进行排序
          this.buildNumbers.sort((a, b) => {
            const isANumber = !isNaN(parseFloat(a)) && isFinite(a);
            const isBNumber = !isNaN(parseFloat(b)) && isFinite(b);
            if (isANumber && isBNumber) {
              return parseFloat(a) - parseFloat(b);
            } else if (isANumber) {
              return -1;
            } else if (isBNumber) {
              return 1;
            }
            return a.localeCompare(b);
          });
          this.tableBuildNumber = this.buildNumbers[0];
          getRoadByCode(code).then((res) => {
            if (res.data.code == 200) {
              result.roadList = res.data.result;
            } 
            houseTypeView = new HouseTypeViewOpen({
              element: document.querySelector("#canvasRender"),
              history: result,
              onChoseBuildNumber: this.onChoseBuildNumber,
              minBaseHeight: minBaseHeight
            });
            houseTypeView.init();
            this.initHouseType(code)
          })
        } else {
          Modal.error({
            title: '提示',
            content: res.data.message || '请求失败',
          })
        }
      })
    },
    initHouseType (code) {
      getHouseType({
        code: code
      }).then((res) => {
        if (res.data.code === 200) {
          this.houseTypes = res.data.result
          this.$refs.houseTypeListComponent.initSelect(this.houseTypes)
        }
      })
    },
    handleTypeSelect(typeId, color, selected) {
      // 这里添加户型选择后的逻辑
      // 示例：更新3D视图显示对应户型
      let selectedTypeIds = []
      selectedTypeIds.push(typeId)
      getHouseListByType({
        code: this.code,
        typeIds: selectedTypeIds
      }).then((res) => {
        if (res.data.code == 200) {
          this.houseList = res.data.result
          houseTypeView.updateRoomColor(this.houseList, color, selected)
        }
      })
    }
  }
}
</script>
<style scoped>
.main-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
}
/* 添加蒙层样式 */
.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(69, 69, 69, 0.8);
  z-index: 1001;
}
</style>